









































































import Vue from "vue";
import {DonationType} from "@/classes/DonationType";
import donationSteps from "@/donationSteps";
import i18n from '@/plugins/i18n';

export default Vue.extend({
  props: {
    donationTypes: {
      type: Array as () => Array<DonationType>
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    showNextButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    donation() {
      return this.$store.state.donation
    },
    currentStep() {
      return this.$store.state.currentStep
    },
  },
  watch: {
    currentStep: {
      handler(newVal, oldVal) {
        if (newVal === donationSteps.step.DONATION_TYPE) {
          if (this.donationTypes.length <= 1) {
            this.$emit('removeStep', donationSteps.step.DONATION_TYPE)

            this.donationTypeClick(this.donationTypes[0])
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    donationTypeClick(donationType: DonationType) {
      this.$emit('nextStep')
      let donation = {donationType: donationType}
      this.$store.commit('updateDonation', donation)
    },
    translateDonationTypeName(donationType: DonationType): string {
      return i18n.translateEntityName(donationType);
    },
    translateDonationTypeDescription(donationType: DonationType): string {
      return i18n.translateEntityDescription(donationType);
    },
  }
});
